import React from 'react';
import { Button, Stack, Typography } from '@mui/material';

import { Modal } from 'components/Modal';

export const DeleteConfirmModal = ({ title, label, name, open, handleClose, onConfirm }) => (
  <Modal title={title} open={open} handleClose={handleClose}>
    <Typography variant="body1" fontWeight={500}>
      Please confirm the deletion of the {label} <span style={{ fontWeight: 'bold' }}>{name}.</span>
    </Typography>
    <Stack direction="row" justifyContent="center" gap={1}>
      <Button variant="outlined" onClick={handleClose}>
        Cancel
      </Button>
      <Button variant="contained" color="primary" onClick={onConfirm}>
        Confirm
      </Button>
    </Stack>
  </Modal>
);
